import React from 'react';
import { colors } from 'components/styles/variables';

interface TriangleArrowProps {
  direction?: 'up' | 'down' | 'left' | 'right';
  size?: number;
  color?: string;
}

const rotateMap: Record<string, number> = {
  up: 180,
  left: 90,
  right: -90,
  down: 0,
};

function TriangleArrow({
  direction = 'down',
  size = 12,
  color = colors.BLACK,
}: TriangleArrowProps): JSX.Element {
  const rotate = rotateMap[direction] ?? rotateMap.down;

  return (
    <svg
      width={size}
      height={size * 0.67}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate}deg)` }}
      aria-hidden="true"
      focusable="false"
    >
      <polygon points="6,7 11,1 1,1" fill={color} />
    </svg>
  );
}

export default TriangleArrow;
